import _ from 'underscore';
import $ from 'jquery';

/**
 * reset input value on pressing ESC key
 */
$.fn.extend({
    resetOnEscape: function (dataAttribute, blur) {

        if (_.isUndefined(dataAttribute) || _.isNull(dataAttribute)) {
            dataAttribute = 'default';
        }

        if (_.isUndefined(blur) || _.isNull(blur)) {
            blur = false;
        }

        return this.each((index, element) => {
            $(element).keyup((event) => {
                const target = $(event.target);

                if (event.keyCode === 27) {
                    const value = (dataAttribute === 'placeholder') ? target.attr(dataAttribute) : target.data(dataAttribute);
                    target.val(value);

                    if (blur) {
                        target.blur();
                    }
                }
            });
        });
    }
});


// WEBPACK FOOTER //
// ./jquery/jquery.resetOnEscape.js